import { render, staticRenderFns } from "./RiskController.vue?vue&type=template&id=5d83eb74&scoped=true&"
import script from "./RiskController.vue?vue&type=script&lang=js&"
export * from "./RiskController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83eb74",
  null
  
)

export default component.exports